import script from "./bank.vue?vue&type=script&setup=true&lang=js"
export * from "./bank.vue?vue&type=script&setup=true&lang=js"

import "./bank.vue?vue&type=style&index=0&id=f43688dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f43688dc"]])

export default __exports__